import './handle-click-type-event';
